export enum LocalStorageKeys {
  token = 'token',
  cookiesAccepted = 'cookies-accepted',
  apiAccessKey = 'apiAccessKey',
  referralParams = 'referralParams',
}
